import React from 'react';

import { __APOIO_SECRETARIAL, __CANDIDATO, __COORDENADOR, __DIGITADOR } from '../../security/RoleConfiguration';
import AuthorizedFunction from '../../security/AuthorizedFunction';

import { Layout } from '../../layouts/private/Private';
import Dashboard from './Dashboard';
import Digitacao from '../Digitacao/Digitacao';
import Acompanhamento from '../Acompanhamento/Acompanhamento';

export const RedirectDashboardOrHomeAdmin = () => {
  return (
    <>
      { AuthorizedFunction([__CANDIDATO]) ? 
        <Dashboard /> 
      : AuthorizedFunction([__DIGITADOR]) ? 
        <Digitacao /> 
      : AuthorizedFunction([__COORDENADOR, __APOIO_SECRETARIAL]) ? 
        <Acompanhamento /> 
      : 
        <Layout /> 
      }
    </>
  )
}

export default RedirectDashboardOrHomeAdmin;